import {COOKIE_TMR_LVID, getCookie} from '@utils/cookies';

import {YANDEX_METRIKA_ID} from '@web-landing/analytics/ids';

export const ym_log = {
  downloadApkRustoreYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'download_apk_rustore');
  },

  downloadApkRustoreAutomaticAndClickYM: () => {
    window.ym(
      YANDEX_METRIKA_ID,
      'reachGoal',
      'download_apk_rustore_automatic_and_click',
    );
  },

  downloadApkRustoreAutomaticYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'download_apk_rustore_automatic');
  },

  error404YM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'error_404', {
      url_311744903: location.href,
    });
  },

  setUserParamsOnYM: () => {
    const tmr_lvid = getCookie(COOKIE_TMR_LVID);

    window.ym(YANDEX_METRIKA_ID, 'userParams', {tmr_lvid});
  },

  downloadFileYM: () => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        currency: 'RUB',
        value: 0,
        transaction_id: new Date().getTime(),
        items: [
          {
            item_name: 'download_file',
            price: '0',
            quantity: '1',
          },
        ],
      },
    });
  },
};
